// src/pages/seller/Seller2Net/services/sellerNetService.js
import api from "../../../../api/axios";

export const getUserTemplate = async (companyId) => {
  try {
    const res = await api.get(`/user-template/group/seller/${companyId}`);
    return res.data?.data || [];
  } catch (err) {
    console.error("getUserTemplate error:", err);
    throw err;
  }
};

export const saveNetFirstCalc = async (payload) => {
  try {
    const res = await api.post(`/netfirst`, payload);
    return res?.data?.data;
  } catch (error) {
    console.error("Save Seller2Net calc error:", error);
    throw error;
  }};

export const updateNetFirstCalc = async (payload)=>{
  try {
    const res = await api.put(`/netfirst/${payload.id}`, payload);
    return res?.data?.data;
  } catch (error) {
    console.error("Update Seller2Net calc error:", error);
    throw error;
  }
}

export const getNetFirstCalc = async (id) => {
  try {
    const res = await api.get(`/netfirst/${id}`);
    return res?.data?.data;
  } catch (error) {
    console.error("Get Seller calc error:", error);
    throw error;
  }
};